import * as React from 'react';
import { errorHandler } from '../../error/handler';
import { getFila, getFilaList } from '../../fetch/place/fila';
import { IFila } from '../../interfaces/place/models';
import { normalizer } from '../../lib/normalizer';
import { useAppDispatch } from '../../store/hooks';
import { emptyAction, getAction, listAction } from '../../store/place/fila/actions';
import { IFilaState } from '../../store/place/fila/types';
import { endActionToDoAction, startActionToDoAction } from '../../store/ui/actions';

export const useFilaGet = (id: number) => {
	const dispatch = useAppDispatch();
	React.useEffect(() => {
		const effect = async () => {
			if (!id) return;
			const actionToDo = 'get-fila';
			try {
				dispatch(startActionToDoAction({ actionToDo }));
				const fila = await getFila(id);
				dispatch(getAction(fila));
				dispatch(endActionToDoAction({ actionToDo, success: true }));
			} catch (err) {
				errorHandler(err, actionToDo);
			}
		}
		effect();
	}, [dispatch, id])
}

export const useFilaList = (query: number) => {
	const dispatch = useAppDispatch();
	React.useEffect(() => {
		const effect = async () => {
			if (!query) return;
			const actionToDo = 'list-fila';
			try {
				dispatch(startActionToDoAction({ actionToDo }));
				const { results, items: _items } = await getFilaList();
				_items.sort((itemA, itemB) => (!!itemA?.ordinamento && !!itemB.ordinamento) ? itemA.ordinamento - itemB.ordinamento : 0);
				const { list, items } = normalizer<number, IFila>(_items, "id");
				const actionPayload: IFilaState = {
					results,
					list,
					items
				}
				dispatch(listAction(actionPayload));
				dispatch(endActionToDoAction({ actionToDo, success: true }));
			} catch (err) {
				errorHandler(err, actionToDo);
			}
			return () => {
				dispatch(emptyAction());
			}
		}
		effect();
	}, [dispatch, query])
}